/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect } from 'react';
import { Container, Card } from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, IconButton, Radio, Button, Box, Grid } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import TokenDecoder from 'src/helpers/TokenDecoder';
import _ from 'lodash';
import permissionAuth from 'src/utils/permissionAuth';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import Paper from '@material-ui/core/Paper';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { AlertDialog } from './../../Common/AlertDialog';

var screenCode = 'VIEWQRTAGGENARATION';

export default function QRTagGenaration(props) {
  const [message, setMessage] = useState('QR Generate Confirmation');
  const [EnableConfirmMessage, setEnableConfirmMessage] = useState(false);
  const [group, setGroup] = useState([]);
  const [factory, setFactory] = useState([]);
  const [QRTagDetails, setQRTagDetails] = useState([]);
  const navigate = useNavigate();
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false
  });

  const [formData, setFormData] = useState({
    groupID: '1',
    operationEntityID: '1',
    noOfCodes: ''
  });
  const productcatogerySearchSchema = Yup.object().shape({
    groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
    operationEntityID: Yup.number()
      .min(1, 'Please Select Fresh Collection Center')
      .required('Fresh Collection Center is Required'),
    noOfCodes: Yup.string()
      .required('No of Codes Required')
      .matches(/\b^([1-9]|[1-9][0-9]|1[0-4][0-9]|150|\.)\b/, "Maximum Integer 150")
  });

  const formik = useFormik({
    initialValues: {
      groupID: formData.groupID,
      operationEntityID: formData.operationEntityID,
      noOfCodes: formData.noOfCodes
    },
    validationSchema: productcatogerySearchSchema,
    onSubmit: (values) => {
      if (setEnableConfirmMessage(true)) {
        trackPromise(handleGenerate(values));
      }
    }
  });

  useEffect(() => {
    getPermissions();
  }, []);

  async function getPermissions() {
    var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find((p) => p.permissionCode == 'QRTAGGENARATION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find((p) => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find((p) => p.permissionCode == 'FACTORYDROPDOWN');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
    });

    setValues({
      ...values,
      groupID: parseInt(TokenDecoder.getGroupFactoryToken().group),
      operationEntityID: parseInt(TokenDecoder.getGroupFactoryToken().factory)
    });
    trackPromise(GetAllGroups());
  }

  const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

  useEffect(() => {
    trackPromise(GetAllGroups());
  }, []);

  useEffect(() => {
    trackPromise(GetFactoriesByGroupID());
  }, [formik.values.groupID]);

  async function GetAllGroups() {
    var res = await services.GetAllGroups();
    if (res != null) {
      setGroup(res);
    }
  }

  useEffect(() => {
    setQRTagDetails([]);
  }, [formik.values.operationEntityID]);

  useEffect(() => {
    setQRTagDetails([]);
  }, [formik.values.noOfCodes]);

  async function GetFactoriesByGroupID() {
    var res = await services.GetFactoriesByGroupID(formik.values.groupID);
    if (res != null) {
      setFactory(res);
    }
  }
  function confirmData(y) {
    if (y) {
      handleGenerate();
    }
  }
  async function handleGenerate() {
    let model = {
      groupID: parseInt(formik.values.groupID),
      operationEntityID: parseInt(formik.values.operationEntityID),
      noOfCodes: formik.values.noOfCodes,
      createdBy: parseInt(TokenDecoder.getUserIDFromToken())
    };
    const response = await services.createQRtag(model);
    setQRTagDetails(response);
  }
  async function handleSave() {
    const response = await services.saveQRtags(QRTagDetails);
    if ((response.statusCode = true)) {
      toast.success('QR Tags Saved Successfully');
      setQRTagDetails([]);
      clearAll();
    } else {
      toast.error('Error occured while saving the QR Tags');
    }
  }

  async function clearAll() {
    formik.resetForm();
  }

  return (
    <>
      <LoadingComponent />
      <Page title="QR Tag Generation |  FAPS">
        <Container>
          <CommonPageHeader
            btname="Add"
            pageName="QR Tag Generation"
            leftButtonHidden={true}
          />
          <FormikProvider value={formik}>
            <ToastContainer position="bottom-right" pauseOnHover />
            <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
              <Stack spacing={2}>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Group *"
                    value={formik.values.groupID}
                    onChange={formik.handleChange}
                    {...getFieldProps('groupID')}
                    error={Boolean(touched.groupID && errors.groupID)}
                    helperText={touched.groupID && errors.groupID}
                    InputProps={{
                      readOnly: !permissionList.isGroupFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Group
                    </MenuItem>
                    {group.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.groupID} value={option.groupID}>
                          {option.groupName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <TextField
                    select
                    fullWidth
                    size="small"
                    label="Fresh Collection Center *"
                    value={formik.values.operationEntityID}
                    onChange={formik.operationEntityID}
                    {...getFieldProps('operationEntityID')}
                    error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                    helperText={touched.operationEntityID && errors.operationEntityID}
                    InputProps={{
                      readOnly: !permissionList.isFactoryFilterEnabled
                    }}
                  >
                    <MenuItem key={0} value={0}>
                      {' '}
                      Select Fresh Collection Center
                    </MenuItem>
                    {factory.map((option) =>
                      option.isActive == true ? (
                        <MenuItem key={option.factoryID} value={option.factoryID}>
                          {option.factoryName}
                        </MenuItem>
                      ) : null
                    )}
                  </TextField>
                  <TextField
                    fullWidth
                    label="No. of codes *"
                    name="noOfCodes"
                    id="noOfCodes"
                    size="small"
                    value={formik.values.noOfCodes}
                    onChange={formik.handleChange}
                    type="number"
                    onInput={(e) => {
                      e.target.value = e.target.value.slice(0, 3)
                    }}
                    error={Boolean(touched.noOfCodes && errors.noOfCodes)}
                    helperText={touched.noOfCodes && errors.noOfCodes}
                  />
                  <Grid>
                  <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                    <Button type="button" variant="outlined" color="error" onClick={() => clearAll()}>
                      {' '}
                      Clear
                    </Button>
                    <Button type="submit" color="secondary" variant="outlined">
                      Genarate
                    </Button>
                  </Stack>
                  </Grid>
                </Stack>
              </Stack>
            </Form>
          </FormikProvider>
          <br />
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
            {QRTagDetails.length > 0 ? (
              <Card style={{ justifycontent: 'center', width: '85rem' }}>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="left">Tag No</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {QRTagDetails.map((row) => (
                        <TableRow key={row.tagNo}>
                          <TableCell align="left">{row.tagNo}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Card>
            ) : null}
          </Stack>
          <br />
          {QRTagDetails.length > 0 ? (
            <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
              <Button
                type="submit"
                color="secondary"
                variant="outlined"
                onClick={() => handleSave()}
              >
                Save
              </Button>
            </Stack>
          ) : null}
        </Container>
        <div hidden={true}>
          <Grid item>
            <AlertDialog
              confirmData={confirmData}
              headerMessage={message}
              viewPopup={EnableConfirmMessage}
              discription={'Are you sure want to generate QR Tag?'}
              setViewPopup={setEnableConfirmMessage}
            />
          </Grid>
        </div>
      </Page>
    </>
  );
}
